module.exports = __webpack_public_path__ + "img/Flag_of_North_Macedonia.96ce9dc5.svg";